import {Component, Input, ChangeDetectionStrategy} from '@angular/core';
import {ServiceDto} from '../../../_services/configuration-services';
import {CraningBookingUtils} from './craning-booking/craning-booking-utils';

@Component({
    selector: 'app-craning',
    templateUrl: './craning.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CraningComponent {

    @Input() service!: ServiceDto;

    CraningView = CraningView;

    craningView = CraningView.BookingView;

    constructor(public readonly craningBookingUtils: CraningBookingUtils) { }

    changeCraningView(view: CraningView): void {
        this.craningView = view;
    }
}

enum CraningView {
    BookingView,
    BillingView
}
